import { api } from '../lib/axios';

export interface TalkToUsPayload {
  fullName: string;
  email: string;
  company?: string;
  topic: string;
  message: string;
  website?: string; // honeypot
}

export async function submitTalkToUs(payload: TalkToUsPayload) {
  const response = await api.post('/contact/talk-to-us', payload);
  return response.data;
}

export interface ContactSalesPayload {
  fullName: string;
  email: string;
  company: string;
  role?: string;
  country: string;
  industry: string;
  productCategory?: string;
  volume?: string;
  goal: string;
  timeline: string;
  message: string;
  website?: string; // honeypot
}

export async function submitContactSales(payload: ContactSalesPayload) {
  const response = await api.post('/contact/contact-sales', payload);
  return response.data;
}
